// extracted by css-extract-rspack-plugin
export default {"settlementQuotaConfig":"settlementQuotaConfig-DuAMqP","leftMenu":"leftMenu-eRpGjk","rightTable":"rightTable-rtFhLP","rightTableTop":"rightTableTop-E_XBSj"};